var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsortiumIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 88,
    viewBox: "0 0 126 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.307 30.1522L9.33891 24.9785C9.18548 24.8899 9.20479 24.7354 9.38188 24.6333L18.2636 19.5094C18.4407 19.4071 18.7087 19.3961 18.8619 19.4845L27.8299 24.6582C27.9834 24.7468 27.9641 24.9013 27.787 25.0034L18.9053 30.1273C18.7282 30.2296 18.4602 30.2406 18.307 30.1522Z",
    fill: "#0076FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5595 32.8061C18.3998 32.8061 18.2466 32.7729 18.1295 32.7055L5.01089 25.1374C4.88176 25.0629 4.81055 24.9548 4.81055 24.8333C4.81055 24.6945 4.90646 24.5596 5.0738 24.4629L18.0664 16.9676C18.3569 16.8 18.7843 16.784 19.0397 16.9313L32.1583 24.4995C32.2877 24.5739 32.3587 24.682 32.3587 24.8036C32.3587 24.9424 32.2628 25.0772 32.0954 25.1739L19.1028 32.6694C18.9454 32.7597 18.7482 32.8061 18.5595 32.8061ZM18.2273 32.536C18.421 32.6478 18.7773 32.6315 19.005 32.4997L31.9976 25.0042C32.1012 24.9444 32.1631 24.8693 32.1631 24.8032C32.1631 24.7407 32.1073 24.6953 32.0606 24.6685L18.9419 17.1002C18.7484 16.9886 18.3922 17.005 18.1642 17.1365L5.17159 24.632C5.06799 24.6918 5.00612 24.7669 5.00612 24.833C5.00612 24.8957 5.06197 24.9409 5.10868 24.9677L18.2273 32.536Z",
    fill: "#0076FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9325 21.1532V19.4247L25.1146 19.4265L18.8624 15.8195C18.7089 15.7309 18.4411 15.7421 18.2638 15.8444L12.0394 19.4352L9.23535 19.4371L9.23577 21.17H9.23743C9.23992 21.2237 9.2721 21.275 9.33895 21.3135L18.307 26.4872C18.4604 26.5758 18.7282 26.5646 18.9055 26.4623L27.7872 21.3384C27.8796 21.2853 27.928 21.2181 27.9325 21.1532Z",
    fill: "url(#paint0_linear_169_467)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3079 24.7586L9.33988 19.5849C9.18646 19.4964 9.20577 19.3418 9.38286 19.2397L18.2645 14.1158C18.4416 14.0136 18.7097 14.0026 18.8629 14.0909L27.8309 19.2646C27.9843 19.3532 27.965 19.5078 27.7879 19.6098L18.9063 24.7337C18.7292 24.836 18.4611 24.847 18.3079 24.7586Z",
    fill: "url(#paint1_linear_169_467)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.339 24.1525L10.3897 19.5665C10.2537 19.4881 10.2707 19.351 10.4277 19.2605L18.3006 14.7185C18.4575 14.6279 18.695 14.6181 18.831 14.6965L26.7803 19.2825C26.9163 19.3609 26.8993 19.4981 26.7423 19.5885L18.8694 24.1305C18.7125 24.2212 18.4749 24.2309 18.339 24.1525Z",
    fill: "#0076FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3592 23.7685L11.056 19.5551C10.931 19.4831 10.9468 19.3572 11.0909 19.274L18.3239 15.1011C18.4682 15.0179 18.6864 15.0088 18.8114 15.0809L26.1146 19.2943C26.2396 19.3663 26.2238 19.4923 26.0797 19.5754L18.8467 23.7482C18.7022 23.8316 18.484 23.8405 18.3592 23.7685Z",
    fill: "#0076FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.2591 16.1209L34.2911 10.9472C34.1376 10.8587 34.1569 10.7041 34.334 10.602L43.2157 5.47813C43.3928 5.37585 43.6608 5.36486 43.814 5.45323L52.7821 10.6269C52.9355 10.7155 52.9162 10.8701 52.7391 10.9721L43.8574 16.096C43.6803 16.1983 43.4123 16.2093 43.2591 16.1209Z",
    fill: "#0076FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5116 18.7749C43.352 18.7749 43.1988 18.7417 43.0817 18.6743L29.963 11.1061C29.8339 11.0317 29.7627 10.9236 29.7627 10.802C29.7627 10.6632 29.8586 10.5284 30.0259 10.4317L43.0186 2.93638C43.309 2.76875 43.7365 2.75278 43.9919 2.90007L57.1105 10.4682C57.2398 10.5427 57.3108 10.6508 57.3108 10.7723C57.3108 10.9111 57.2149 11.046 57.0476 11.1426L44.055 18.6382C43.8976 18.7284 43.7004 18.7749 43.5116 18.7749ZM43.1795 18.5048C43.3732 18.6166 43.7294 18.6002 43.9572 18.4685L56.9498 10.9729C57.0534 10.9132 57.1153 10.8381 57.1153 10.7719C57.1153 10.7095 57.0594 10.664 57.0127 10.6373L43.8941 3.06894C43.7006 2.95733 43.3443 2.97372 43.1164 3.10524L30.1237 10.6008C30.0201 10.6605 29.9583 10.7356 29.9583 10.8018C29.9583 10.8644 30.0141 10.9097 30.0608 10.9364L43.1795 18.5048Z",
    fill: "#0076FC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8847 7.12193V5.39342L50.0668 5.39528L43.8145 1.78828C43.6611 1.6997 43.3933 1.7109 43.216 1.81317L36.9915 5.404L34.1875 5.40586L34.1879 7.13873H34.1896C34.1921 7.19246 34.2242 7.2437 34.2911 7.28229L43.2591 12.456C43.4126 12.5446 43.6804 12.5334 43.8577 12.4311L52.7394 7.30718C52.8318 7.25407 52.8801 7.18686 52.8847 7.12193Z",
    fill: "url(#paint2_linear_169_467)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2601 10.7274L34.292 5.55369C34.1386 5.46511 34.1579 5.31055 34.335 5.20848L43.2167 0.0845749C43.3938 -0.0177 43.6618 -0.0286972 43.815 0.0596783L52.7831 5.23338C52.9365 5.32196 52.9172 5.47651 52.7401 5.57858L43.8584 10.7025C43.6813 10.8048 43.4133 10.8158 43.2601 10.7274Z",
    fill: "url(#paint3_linear_169_467)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2911 10.1212L35.3418 5.53526C35.2058 5.45684 35.2229 5.31971 35.3798 5.22926L43.2527 0.687261C43.4097 0.596604 43.6472 0.586853 43.7832 0.66527L51.7324 5.25125C51.8684 5.32967 51.8514 5.4668 51.6944 5.55725L43.8216 10.0993C43.6646 10.1899 43.4271 10.1997 43.2911 10.1212Z",
    fill: "#0076FC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3114 9.73726L36.0082 5.52386C35.8832 5.45188 35.899 5.32595 36.0431 5.24276L43.2761 1.06982C43.4204 0.986633 43.6386 0.977505 43.7636 1.0497L51.0668 5.26309C51.1917 5.33508 51.176 5.461 51.0319 5.54419L43.7989 9.71693C43.6544 9.80033 43.4362 9.80925 43.3114 9.73726Z",
    fill: "#0076FC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50.1341 53.2552L41.1661 48.0815C41.0126 47.9929 41.0319 47.8384 41.209 47.7363L50.0907 42.6124C50.2678 42.5101 50.5358 42.4991 50.689 42.5875L59.6571 47.7612C59.8105 47.8498 59.7912 48.0043 59.6141 48.1064L50.7324 53.2303C50.5553 53.3326 50.2873 53.3436 50.1341 53.2552Z",
    fill: "#0076FC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3866 55.9092C50.227 55.9092 50.0738 55.876 49.9567 55.8085L36.838 48.2404C36.7089 48.1659 36.6377 48.0578 36.6377 47.9363C36.6377 47.7975 36.7336 47.6626 36.9009 47.566L49.8936 40.0707C50.184 39.903 50.6115 39.8871 50.8669 40.0343L63.9855 47.6025C64.1148 47.677 64.1858 47.785 64.1858 47.9066C64.1858 48.0454 64.0899 48.1802 63.9226 48.2769L50.93 55.7724C50.7726 55.8627 50.5754 55.9092 50.3866 55.9092ZM50.0545 55.6391C50.2482 55.7509 50.6044 55.7345 50.8322 55.6027L63.8248 48.1072C63.9284 48.0475 63.9903 47.9724 63.9903 47.9062C63.9903 47.8438 63.9344 47.7983 63.8877 47.7716L50.7691 40.2032C50.5756 40.0916 50.2193 40.108 49.9914 40.2395L36.9987 47.735C36.8951 47.7948 36.8333 47.8699 36.8333 47.9361C36.8333 47.9987 36.8891 48.0439 36.9358 48.0707L50.0545 55.6391Z",
    fill: "#0076FC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7597 44.2562V42.5277L56.9418 42.5296L50.6895 38.9226C50.5361 38.834 50.2683 38.8452 50.091 38.9475L43.8665 42.5383L41.0625 42.5401L41.0629 44.273H41.0646C41.0671 44.3267 41.0992 44.378 41.1661 44.4166L50.1341 49.5903C50.2876 49.6788 50.5554 49.6676 50.7327 49.5654L59.6144 44.4415C59.7068 44.3884 59.7551 44.3211 59.7597 44.2562Z",
    fill: "url(#paint4_linear_169_467)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1351 47.8617L41.167 42.688C41.0136 42.5994 41.0329 42.4448 41.21 42.3428L50.0917 37.2189C50.2688 37.1166 50.5368 37.1056 50.69 37.194L59.6581 42.3677C59.8115 42.4562 59.7922 42.6108 59.6151 42.7129L50.7334 47.8368C50.5563 47.939 50.2883 47.95 50.1351 47.8617Z",
    fill: "url(#paint5_linear_169_467)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1661 47.2555L42.2168 42.6695C42.0808 42.5911 42.0979 42.454 42.2548 42.3635L50.1277 37.8215C50.2847 37.7309 50.5222 37.7211 50.6582 37.7995L58.6074 42.3855C58.7434 42.4639 58.7264 42.6011 58.5694 42.6915L50.6966 47.2335C50.5396 47.3242 50.3021 47.3339 50.1661 47.2555Z",
    fill: "#0076FC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1864 46.8715L42.8832 42.6581C42.7582 42.5862 42.774 42.4602 42.9181 42.377L50.1511 38.2041C50.2954 38.1209 50.5136 38.1118 50.6386 38.184L57.9418 42.3974C58.0667 42.4694 58.051 42.5953 57.9069 42.6785L50.6739 46.8512C50.5294 46.9346 50.3112 46.9435 50.1864 46.8715Z",
    fill: "#0076FC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5847 46.7737C18.4028 46.7737 18.2211 46.7268 18.0588 46.6334L0.154465 36.314C0.057717 36.2582 0 36.1582 0 36.0466C0 35.935 0.0577169 35.835 0.154672 35.7794L11.9533 28.9727L12.0511 29.1419L0.25225 35.9487C0.201178 35.9782 0.195572 36.0269 0.195572 36.0466C0.195572 36.0663 0.20097 36.1153 0.25225 36.1448L18.1566 46.4642C18.4207 46.6164 18.7487 46.6164 19.0126 46.464L33.9748 38.01L34.0711 38.1801L19.1097 46.6336C18.948 46.727 18.7663 46.7737 18.5847 46.7737Z",
    fill: "#0076FC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M84.9534 48.1268L75.9854 42.9531C75.832 42.8645 75.8513 42.71 76.0284 42.6079L84.91 37.484C85.0871 37.3817 85.3552 37.3707 85.5084 37.4591L94.4764 42.6328C94.6298 42.7214 94.6105 42.8759 94.4335 42.978L85.5518 48.1019C85.3749 48.2042 85.1069 48.2152 84.9534 48.1268Z",
    fill: "#0076FC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2071 50.4506C85.0533 50.4506 84.9056 50.4187 84.7929 50.3535L72.2234 43.1022C72.098 43.0298 72.0293 42.925 72.0293 42.8072C72.0295 42.6728 72.1221 42.5421 72.2838 42.4487L84.7325 35.2669C85.0122 35.1059 85.4236 35.0905 85.6693 35.2322L98.2388 42.4838C98.3637 42.556 98.4329 42.6605 98.4329 42.7786C98.4329 42.913 98.3401 43.0435 98.1785 43.1368L85.7299 50.3187C85.5783 50.406 85.3884 50.4506 85.2071 50.4506ZM85.2567 35.331C85.1083 35.331 84.9503 35.3668 84.8299 35.4363L72.3812 42.6182C72.2832 42.6746 72.2247 42.7454 72.2247 42.8072C72.2247 42.8651 72.277 42.9074 72.321 42.9327L84.8905 50.1841C85.0753 50.2909 85.4145 50.2749 85.6317 50.1494L98.0804 42.9676C98.1783 42.9111 98.2369 42.8404 98.2369 42.7786C98.2369 42.7209 98.1846 42.6786 98.1406 42.6531L85.5711 35.4015C85.4888 35.354 85.3759 35.331 85.2567 35.331Z",
    fill: "#0076FC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5788 39.3602V37.6317L91.7609 37.6336L85.5088 34.0266C85.3554 33.938 85.0874 33.9492 84.9103 34.0515L78.6859 37.6423L75.8818 37.6441L75.8822 39.377H75.8839C75.8864 39.4307 75.9186 39.482 75.9854 39.5206L84.9535 44.6943C85.1069 44.7829 85.3747 44.7717 85.552 44.6696L94.4337 39.5457C94.5259 39.4924 94.5743 39.4251 94.5788 39.3602Z",
    fill: "url(#paint6_linear_169_467)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9532 42.9656L75.9854 37.7919C75.832 37.7036 75.8513 37.5488 76.0284 37.4467L84.91 32.3228C85.0871 32.2205 85.3552 32.2095 85.5084 32.2981L94.4764 37.4718C94.6299 37.5604 94.6105 37.715 94.4334 37.817L85.5518 42.9409C85.3747 43.043 85.1067 43.054 84.9532 42.9656Z",
    fill: "url(#paint7_linear_169_467)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9532 42.9656L75.9854 37.7919C75.832 37.7036 75.8513 37.5488 76.0284 37.4467L84.91 32.3228C85.0871 32.2205 85.3552 32.2095 85.5084 32.2981L94.4764 37.4718C94.6299 37.5604 94.6105 37.715 94.4334 37.817L85.5518 42.9409C85.3747 43.043 85.1067 43.054 84.9532 42.9656Z",
    fill: "url(#paint8_linear_169_467)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9854 42.3595L77.0361 37.7735C76.9002 37.6951 76.9172 37.558 77.0743 37.4675L84.9472 32.9255C85.1042 32.8349 85.3417 32.8251 85.4777 32.9036L93.427 37.4895C93.5629 37.568 93.5459 37.7051 93.389 37.7955L85.5161 42.3375C85.3589 42.4282 85.1214 42.4379 84.9854 42.3595Z",
    fill: "#0076FC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0047 41.9753L77.7015 37.7619C77.5766 37.69 77.5923 37.564 77.7364 37.4808L84.9694 33.3081C85.1137 33.2249 85.3319 33.2158 85.4569 33.288L92.7601 37.5014C92.8851 37.5734 92.8693 37.6993 92.725 37.7825L85.492 41.9552C85.3479 42.0384 85.1297 42.0473 85.0047 41.9753Z",
    fill: "#0076FC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0631 37.3575L84.209 36.8648L84.6753 36.5957L85.5294 37.0884L85.0631 37.3575Z",
    fill: "#0076FC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6505 37.2876L85.7966 37.7803L85.3301 37.5113L86.1842 37.0186L86.6505 37.2876Z",
    fill: "#0076FC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8691 37.4693L84.4028 37.7383L83.9365 37.4693L84.4028 37.2002L84.8691 37.4693Z",
    fill: "#0076FC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4811 38.3987L86.0148 38.6678L84.6699 37.8921L85.1364 37.623L86.4811 38.3987Z",
    fill: "#0076FC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M94.5796 35.3075L90.7648 35.3301L85.5082 32.2976C85.3548 32.209 85.0868 32.2202 84.9097 32.3223L79.5811 35.3963L75.8818 35.4183V37.664L75.8841 37.6652C75.8924 37.7128 75.9252 37.7571 75.9848 37.7914L84.9529 42.9651C85.1063 43.0537 85.3741 43.0425 85.5514 42.9404L94.4331 37.8165C94.5138 37.7698 94.5601 37.7123 94.5738 37.6551L94.5796 37.6518V35.3075Z",
    fill: "#0076FC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M94.579 35.5301V33.8016L91.7611 33.8035L85.5088 30.1965C85.3554 30.1079 85.0874 30.1191 84.9103 30.2212L78.6859 33.812L75.8818 33.8139L75.8822 35.5467H75.8839C75.8864 35.6005 75.9186 35.6517 75.9854 35.6903L84.9535 40.864C85.1069 40.9526 85.3747 40.9414 85.552 40.8391L94.4337 35.7152C94.5261 35.6623 94.5745 35.5949 94.579 35.5301Z",
    fill: "url(#paint9_linear_169_467)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9534 39.1351L75.9854 33.9614C75.832 33.8728 75.8513 33.7183 76.0284 33.6162L84.91 28.4923C85.0871 28.39 85.3552 28.379 85.5084 28.4674L94.4764 33.6411C94.6298 33.7297 94.6105 33.8842 94.4335 33.9863L85.5518 39.1102C85.3749 39.2125 85.1069 39.2237 84.9534 39.1351Z",
    fill: "url(#paint10_linear_169_467)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9854 38.5294L77.0361 33.9435C76.9002 33.865 76.9172 33.7279 77.0743 33.6375L84.9472 29.0955C85.1042 29.0048 85.3417 28.9951 85.4777 29.0735L93.427 33.6595C93.5629 33.7379 93.5459 33.875 93.389 33.9655L85.5161 38.5074C85.3589 38.5979 85.1214 38.6079 84.9854 38.5294Z",
    fill: "#0076FC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0047 38.1453L77.7015 33.9319C77.5766 33.8599 77.5923 33.7339 77.7364 33.6508L84.9694 29.478C85.1137 29.3948 85.3319 29.3857 85.4569 29.4579L92.7601 33.6713C92.8851 33.7433 92.8693 33.8692 92.725 33.9524L85.492 38.1251C85.3479 38.2083 85.1297 38.2172 85.0047 38.1453Z",
    fill: "#0076FC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8389 22.1094L38.1704 15.7664",
    stroke: "#0076FC",
    strokeWidth: 0.2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5896 48.9591L70.8942 53.4194L80.3405 47.6107",
    stroke: "#0076FC",
    strokeWidth: 0.2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3922 68.9784L102.036 64.933L105.98 62.4436",
    stroke: "#0076FC",
    strokeWidth: 0.2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5237 38.3791L36.9493 36.4083L44.2157 40.5574",
    stroke: "#0076FC",
    strokeWidth: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.659 25.8714L97.6914 20.6977C97.538 20.6091 97.5573 20.4546 97.7344 20.3525L106.616 15.2286C106.793 15.1263 107.061 15.1153 107.214 15.2037L116.182 20.3774C116.336 20.466 116.317 20.6206 116.14 20.7226L107.258 25.8465C107.081 25.9488 106.813 25.9598 106.659 25.8714Z",
    fill: "#0076FC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M106.912 28.5254C106.752 28.5254 106.599 28.4922 106.482 28.4248L93.3634 20.8566C93.2343 20.7821 93.1631 20.6741 93.1631 20.5525C93.1631 20.4137 93.259 20.2789 93.4263 20.1822L106.419 12.6869C106.709 12.5192 107.137 12.5033 107.392 12.6506L120.511 20.2187C120.64 20.2932 120.711 20.4013 120.711 20.5228C120.711 20.6616 120.615 20.7965 120.448 20.8931L107.455 28.3887C107.298 28.4789 107.101 28.5254 106.912 28.5254ZM106.58 28.2553C106.774 28.3671 107.13 28.3507 107.358 28.219L120.35 20.7234C120.454 20.6637 120.516 20.5886 120.516 20.5224C120.516 20.46 120.46 20.4145 120.413 20.3878L107.294 12.8194C107.101 12.7078 106.745 12.7242 106.517 12.8557L93.5241 20.3513C93.4205 20.411 93.3587 20.4861 93.3587 20.5523C93.3587 20.6149 93.4145 20.6602 93.4612 20.6869L106.58 28.2553Z",
    fill: "#0076FC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M116.285 16.8724V15.1439L113.467 15.1458L107.215 11.5388C107.061 11.4502 106.794 11.4614 106.616 11.5637L100.392 15.1545L97.5879 15.1564L97.5883 16.8892H97.59C97.5925 16.9429 97.6246 16.9942 97.6915 17.0328L106.66 22.2065C106.813 22.2951 107.081 22.2839 107.258 22.1816L116.14 17.0577C116.232 17.0046 116.281 16.9373 116.285 16.8724Z",
    fill: "url(#paint11_linear_169_467)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M106.66 20.4779L97.6924 15.3042C97.539 15.2156 97.5583 15.061 97.7354 14.959L106.617 9.83506C106.794 9.73279 107.062 9.72179 107.215 9.81017L116.183 14.9839C116.337 15.0724 116.318 15.227 116.14 15.3291L107.259 20.453C107.082 20.5553 106.814 20.5663 106.66 20.4779Z",
    fill: "url(#paint12_linear_169_467)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M106.692 19.8717L98.7422 15.2857C98.6062 15.2073 98.6233 15.0702 98.7802 14.9798L106.653 10.4377C106.81 10.3471 107.048 10.3373 107.184 10.4158L115.133 15.0017C115.269 15.0802 115.252 15.2173 115.095 15.3077L107.222 19.8497C107.065 19.9404 106.827 19.9501 106.692 19.8717Z",
    fill: "#0076FC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M106.712 19.4877L99.4086 15.2744C99.2836 15.2024 99.2994 15.0764 99.4435 14.9933L106.676 10.8203C106.821 10.7371 107.039 10.728 107.164 10.8002L114.467 15.0136C114.592 15.0856 114.576 15.2115 114.432 15.2947L107.199 19.4674C107.055 19.5508 106.837 19.5597 106.712 19.4877Z",
    fill: "#0076FC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.596 67.701L14.628 62.5273C14.4745 62.4387 14.4939 62.2842 14.6709 62.1821L23.5526 57.0582C23.7297 56.9559 23.9977 56.9449 24.151 57.0333L33.119 62.207C33.2724 62.2956 33.2531 62.4501 33.076 62.5522L24.1944 67.6761C24.0173 67.7784 23.7492 67.7894 23.596 67.701Z",
    fill: "#0076FC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8486 70.355C23.6889 70.355 23.5357 70.3218 23.4186 70.2543L10.3 62.6862C10.1708 62.6117 10.0996 62.5036 10.0996 62.3821C10.0996 62.2433 10.1955 62.1084 10.3629 62.0118L23.3555 54.5165C23.6459 54.3488 24.0734 54.3329 24.3288 54.4801L37.4474 62.0483C37.5767 62.1228 37.6478 62.2308 37.6478 62.3524C37.6478 62.4912 37.5518 62.626 37.3845 62.7227L24.3919 70.2182C24.2345 70.3085 24.0373 70.355 23.8486 70.355ZM23.5164 70.0849C23.7101 70.1967 24.0663 70.1803 24.2941 70.0485L37.2867 62.553C37.3903 62.4933 37.4522 62.4182 37.4522 62.352C37.4522 62.2896 37.3963 62.2441 37.3496 62.2174L24.231 54.649C24.0375 54.5374 23.6812 54.5538 23.4533 54.6853L10.4606 62.1808C10.357 62.2406 10.2952 62.3157 10.2952 62.3819C10.2952 62.4445 10.351 62.4897 10.3977 62.5165L23.5164 70.0849Z",
    fill: "#0076FC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2216 58.702V56.9735L30.4037 56.9754L24.1514 53.3684C23.998 53.2798 23.7302 53.291 23.5529 53.3933L17.3284 56.9841L14.5244 56.9859L14.5248 58.7188H14.5265C14.529 58.7725 14.5612 58.8238 14.628 58.8624L23.5961 64.0361C23.7495 64.1247 24.0173 64.1134 24.1946 64.0112L33.0763 58.8873C33.1687 58.8342 33.217 58.7669 33.2216 58.702Z",
    fill: "url(#paint13_linear_169_467)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M23.597 62.3075L14.6289 57.1338C14.4755 57.0452 14.4948 56.8906 14.6719 56.7886L23.5536 51.6647C23.7307 51.5624 23.9987 51.5514 24.1519 51.6398L33.12 56.8135C33.2734 56.902 33.2541 57.0566 33.077 57.1587L24.1953 62.2826C24.0182 62.3848 23.7502 62.3958 23.597 62.3075Z",
    fill: "url(#paint14_linear_169_467)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M23.628 61.7013L15.6787 57.1153C15.5428 57.0369 15.5598 56.8998 15.7167 56.8093L23.5896 52.2673C23.7466 52.1767 23.9841 52.1669 24.1201 52.2453L32.0694 56.8313C32.2053 56.9097 32.1883 57.0469 32.0314 57.1373L24.1585 61.6793C24.0015 61.77 23.764 61.7797 23.628 61.7013Z",
    fill: "#0076FC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6483 61.3173L16.3451 57.1039C16.2201 57.032 16.2359 56.906 16.38 56.8228L23.613 52.6499C23.7573 52.5667 23.9755 52.5576 24.1005 52.6298L31.4037 56.8432C31.5286 56.9152 31.5129 57.0411 31.3688 57.1243L24.1358 61.297C23.9913 61.3804 23.7731 61.3893 23.6483 61.3173Z",
    fill: "#0076FC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M61.7611 74.6229L52.793 69.4492C52.6396 69.3606 52.6589 69.2061 52.836 69.104L61.7177 63.9801C61.8948 63.8778 62.1628 63.8668 62.316 63.9552L71.284 69.1289C71.4375 69.2175 71.4182 69.372 71.2411 69.4741L62.3594 74.598C62.1823 74.7003 61.9143 74.7113 61.7611 74.6229Z",
    fill: "#0076FC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0136 77.2768C61.8539 77.2768 61.7007 77.2436 61.5836 77.1762L48.465 69.6081C48.3359 69.5336 48.2646 69.4255 48.2646 69.304C48.2646 69.1652 48.3606 69.0303 48.5279 68.9336L61.5205 61.4383C61.811 61.2707 62.2384 61.2547 62.4938 61.402L75.6124 68.9702C75.7418 69.0446 75.8128 69.1527 75.8128 69.2743C75.8128 69.4131 75.7169 69.5479 75.5495 69.6446L62.5569 77.1401C62.3995 77.2304 62.2023 77.2768 62.0136 77.2768ZM61.6814 77.0067C61.8751 77.1185 62.2314 77.1022 62.4591 76.9704L75.4517 69.4749C75.5553 69.4152 75.6172 69.34 75.6172 69.2739C75.6172 69.2114 75.5614 69.166 75.5147 69.1392L62.396 61.5709C62.2025 61.4593 61.8463 61.4757 61.6183 61.6072L48.6257 69.1027C48.5221 69.1625 48.4602 69.2376 48.4602 69.3037C48.4602 69.3664 48.5161 69.4116 48.5628 69.4384L61.6814 77.0067Z",
    fill: "#0076FC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3866 65.6239V63.8954L68.5687 63.8972L62.3165 60.2902C62.163 60.2016 61.8952 60.2129 61.7179 60.3151L55.4935 63.906L52.6895 63.9078L52.6899 65.6407H52.6915C52.694 65.6944 52.7262 65.7457 52.7931 65.7842L61.7611 70.9579C61.9145 71.0465 62.1823 71.0353 62.3596 70.933L71.2413 65.8091C71.3337 65.756 71.3821 65.6888 71.3866 65.6239Z",
    fill: "url(#paint15_linear_169_467)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M61.762 69.2293L52.794 64.0556C52.6406 63.9671 52.6599 63.8125 52.837 63.7104L61.7186 58.5865C61.8957 58.4843 62.1638 58.4733 62.317 58.5616L71.285 63.7353C71.4384 63.8239 71.4191 63.9785 71.242 64.0805L62.3604 69.2044C62.1833 69.3067 61.9152 69.3177 61.762 69.2293Z",
    fill: "url(#paint16_linear_169_467)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7931 68.6232L53.8438 64.0372C53.7078 63.9588 53.7248 63.8217 53.8818 63.7312L61.7547 59.1892C61.9116 59.0986 62.1491 59.0888 62.2851 59.1672L70.2344 63.7532C70.3704 63.8316 70.3534 63.9688 70.1964 64.0592L62.3235 68.6012C62.1666 68.6919 61.9291 68.7016 61.7931 68.6232Z",
    fill: "#0076FC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8133 68.2392L54.5101 64.0258C54.3852 63.9538 54.4009 63.8279 54.545 63.7447L61.778 59.5718C61.9223 59.4886 62.1405 59.4795 62.2655 59.5517L69.5687 63.765C69.6937 63.837 69.6779 63.963 69.5338 64.0461L62.3008 68.2189C62.1563 68.3023 61.9381 68.3112 61.8133 68.2392Z",
    fill: "#0076FC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8728 84.323C23.6909 84.323 23.5092 84.2761 23.3469 84.1828L5.44255 73.8634C5.3458 73.8076 5.28809 73.7076 5.28809 73.596C5.28809 73.4843 5.3458 73.3844 5.44276 73.3288L17.2414 66.522L17.3392 66.6913L5.54034 73.498C5.48926 73.5275 5.48366 73.5762 5.48366 73.596C5.48366 73.6157 5.48906 73.6646 5.54034 73.6941L23.4447 84.0135C23.7087 84.1657 24.0368 84.1657 24.3006 84.0133L39.2629 75.5593L39.3592 75.7294L24.3978 84.183C24.2361 84.2763 24.0544 84.323 23.8728 84.323Z",
    fill: "#0076FC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M90.2415 85.6761L81.2735 80.5024C81.1201 80.4138 81.1394 80.2593 81.3165 80.1572L90.1981 75.0333C90.3752 74.931 90.6432 74.92 90.7965 75.0084L99.7645 80.1821C99.9179 80.2707 99.8986 80.4252 99.7215 80.5273L90.8399 85.6512C90.663 85.7535 90.3949 85.7645 90.2415 85.6761Z",
    fill: "#0076FC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4952 88C90.3414 88 90.1937 87.968 90.081 87.9029L77.5115 80.6515C77.3861 80.5791 77.3174 80.4743 77.3174 80.3565C77.3176 80.2221 77.4102 80.0914 77.5719 79.998L90.0206 72.8162C90.3002 72.6552 90.7117 72.6398 90.9573 72.7815L103.527 80.0331C103.652 80.1053 103.721 80.2098 103.721 80.3279C103.721 80.4623 103.628 80.5928 103.467 80.6862L91.018 87.868C90.8664 87.9553 90.6764 88 90.4952 88ZM90.5448 72.8803C90.3964 72.8803 90.2384 72.9162 90.118 72.9857L77.6693 80.1675C77.5713 80.2239 77.5127 80.2947 77.5127 80.3565C77.5127 80.4144 77.5651 80.4567 77.6091 80.482L90.1786 87.7334C90.3634 87.8402 90.7026 87.8242 90.9198 87.6987L103.368 80.5169C103.466 80.4604 103.525 80.3897 103.525 80.3279C103.525 80.2702 103.473 80.2279 103.429 80.2024L90.8591 72.9508C90.7769 72.9033 90.664 72.8803 90.5448 72.8803Z",
    fill: "#0076FC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8669 76.9095V75.181L97.049 75.1829L90.7969 71.5759C90.6435 71.4873 90.3755 71.4985 90.1984 71.6008L83.9739 75.1916L81.1699 75.1935L81.1703 76.9263H81.172C81.1745 76.9801 81.2067 77.0313 81.2735 77.0699L90.2416 82.2436C90.395 82.3322 90.6628 82.321 90.8401 82.2189L99.7218 77.095C99.814 77.0417 99.8623 76.9745 99.8669 76.9095Z",
    fill: "url(#paint17_linear_169_467)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2413 80.515L81.2735 75.3413C81.1201 75.2529 81.1394 75.0981 81.3164 74.9961L90.1981 69.8721C90.3752 69.7699 90.6433 69.7589 90.7965 69.8474L99.7645 75.0212C99.9179 75.1097 99.8986 75.2643 99.7215 75.3664L90.8399 80.4903C90.6628 80.5923 90.3947 80.6033 90.2413 80.515Z",
    fill: "url(#paint18_linear_169_467)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2413 80.515L81.2735 75.3413C81.1201 75.2529 81.1394 75.0981 81.3164 74.9961L90.1981 69.8721C90.3752 69.7699 90.6433 69.7589 90.7965 69.8474L99.7645 75.0212C99.9179 75.1097 99.8986 75.2643 99.7215 75.3664L90.8399 80.4903C90.6628 80.5923 90.3947 80.6033 90.2413 80.515Z",
    fill: "url(#paint19_linear_169_467)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2735 79.9088L82.3242 75.3229C82.1882 75.2444 82.2053 75.1073 82.3624 75.0169L90.2353 70.4749C90.3923 70.3842 90.6298 70.3744 90.7658 70.4529L98.715 75.0389C98.851 75.1173 98.834 75.2544 98.6771 75.3448L90.8042 79.8868C90.647 79.9775 90.4095 79.9873 90.2735 79.9088Z",
    fill: "#0076FC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2928 79.5246L82.9896 75.3113C82.8646 75.2393 82.8804 75.1133 83.0245 75.0302L90.2575 70.8574C90.4018 70.7742 90.62 70.7651 90.745 70.8373L98.0482 75.0507C98.1732 75.1227 98.1574 75.2486 98.0131 75.3318L90.7801 79.5045C90.636 79.5877 90.4178 79.5966 90.2928 79.5246Z",
    fill: "#0076FC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3512 74.9068L89.4971 74.4141L89.9634 74.145L90.8175 74.6377L90.3512 74.9068Z",
    fill: "#0076FC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9386 74.8369L91.0847 75.3296L90.6182 75.0606L91.4723 74.5679L91.9386 74.8369Z",
    fill: "#0076FC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1572 75.0186L89.6909 75.2877L89.2246 75.0186L89.6909 74.7495L90.1572 75.0186Z",
    fill: "#0076FC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7692 75.948L91.3029 76.2171L89.958 75.4414L90.4245 75.1724L91.7692 75.948Z",
    fill: "#0076FC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M99.8677 72.8568L96.0529 72.8795L90.7963 69.8469C90.6429 69.7583 90.3749 69.7695 90.1978 69.8716L84.8692 72.9456L81.1699 72.9676V75.2133L81.1722 75.2146C81.1805 75.2621 81.2133 75.3065 81.2729 75.3407L90.2409 80.5144C90.3944 80.603 90.6622 80.5918 90.8395 80.4897L99.7212 75.3658C99.8019 75.3191 99.8482 75.2617 99.8619 75.2044L99.8677 75.2011V72.8568Z",
    fill: "#0076FC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8661 73.0795V71.351L97.0482 71.3528L90.796 67.7458C90.6425 67.6572 90.3745 67.6684 90.1974 67.7705L83.973 71.3613L81.1689 71.3632L81.1694 73.0961H81.171C81.1735 73.1498 81.2057 73.201 81.2725 73.2396L90.2406 78.4133C90.394 78.5019 90.6618 78.4907 90.8391 78.3884L99.7208 73.2645C99.8132 73.2116 99.8616 73.1442 99.8661 73.0795Z",
    fill: "url(#paint20_linear_169_467)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2405 76.6844L81.2725 71.5107C81.1191 71.4221 81.1384 71.2676 81.3155 71.1655L90.1972 66.0416C90.3742 65.9393 90.6423 65.9283 90.7955 66.0167L99.7635 71.1904C99.917 71.279 99.8977 71.4335 99.7206 71.5356L90.8389 76.6595C90.662 76.7618 90.394 76.773 90.2405 76.6844Z",
    fill: "url(#paint21_linear_169_467)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2725 76.0788L82.3233 71.4928C82.1873 71.4144 82.2043 71.2772 82.3614 71.1868L90.2343 66.6448C90.3913 66.5541 90.6288 66.5444 90.7648 66.6228L98.7141 71.2088C98.8501 71.2872 98.833 71.4243 98.6761 71.5148L90.8032 76.0568C90.646 76.1472 90.4085 76.1572 90.2725 76.0788Z",
    fill: "#0076FC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2918 75.6946L82.9887 71.4812C82.8637 71.4092 82.8794 71.2833 83.0235 71.2001L90.2565 67.0273C90.4008 66.9442 90.619 66.935 90.744 67.0072L98.0472 71.2206C98.1722 71.2926 98.1564 71.4185 98.0121 71.5017L90.7791 75.6744C90.635 75.7576 90.4168 75.7666 90.2918 75.6946Z",
    fill: "#0076FC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3369 73.2311L78.9909 79.2473",
    stroke: "#0076FC",
    strokeWidth: 0.2
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3162 45.8002L103.593 52.2785",
    stroke: "#0076FC",
    strokeWidth: 0.2
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2326 75.6173L45.0459 79.4552L55.5303 73.5428",
    stroke: "#0076FC",
    strokeWidth: 0.2
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M111.949 63.4207L102.981 58.247C102.827 58.1585 102.846 58.0039 103.023 57.9018L111.905 52.7779C112.082 52.6757 112.35 52.6647 112.503 52.753L121.472 57.9267C121.625 58.0153 121.606 58.1699 121.429 58.2719L112.547 63.3959C112.37 63.4981 112.102 63.5091 111.949 63.4207Z",
    fill: "#0076FC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M112.201 66.0747C112.041 66.0747 111.888 66.0415 111.771 65.9741L98.6525 58.4059C98.5234 58.3315 98.4521 58.2234 98.4521 58.1018C98.4521 57.963 98.5481 57.8282 98.7154 57.7315L111.708 50.2362C111.998 50.0686 112.426 50.0526 112.681 50.1999L125.8 57.768C125.929 57.8425 126 57.9506 126 58.0721C126 58.2109 125.904 58.3458 125.737 58.4424L112.744 65.938C112.587 66.0282 112.39 66.0747 112.201 66.0747ZM111.869 65.8046C112.063 65.9164 112.419 65.9 112.647 65.7683L125.639 58.2728C125.743 58.213 125.805 58.1379 125.805 58.0717C125.805 58.0093 125.749 57.9638 125.702 57.9371L112.584 50.3687C112.39 50.2571 112.034 50.2735 111.806 50.405L98.8132 57.9006C98.7096 57.9603 98.6477 58.0354 98.6477 58.1016C98.6477 58.1643 98.7036 58.2095 98.7503 58.2362L111.869 65.8046Z",
    fill: "#0076FC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M121.574 54.4217V52.6932L118.756 52.6951L112.504 49.0881C112.351 48.9995 112.083 49.0107 111.905 49.113L105.681 52.7038L102.877 52.7057L102.877 54.4385H102.879C102.882 54.4923 102.914 54.5435 102.981 54.5821L111.949 59.7558C112.102 59.8444 112.37 59.8332 112.547 59.7309L121.429 54.607C121.521 54.5539 121.57 54.4867 121.574 54.4217Z",
    fill: "url(#paint22_linear_169_467)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M111.95 58.0272L102.981 52.8535C102.828 52.7649 102.847 52.6104 103.024 52.5083L111.906 47.3844C112.083 47.2821 112.351 47.2711 112.504 47.3595L121.473 52.5332C121.626 52.6218 121.607 52.7763 121.43 52.8784L112.548 58.0023C112.371 58.1046 112.103 58.1156 111.95 58.0272Z",
    fill: "url(#paint23_linear_169_467)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M111.981 57.421L104.031 52.8351C103.895 52.7566 103.912 52.6195 104.069 52.5291L111.942 47.9871C112.099 47.8964 112.337 47.8867 112.473 47.9651L120.422 52.5511C120.558 52.6295 120.541 52.7666 120.384 52.8571L112.511 57.3991C112.354 57.4897 112.117 57.4995 111.981 57.421Z",
    fill: "#0076FC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M112.001 57.0371L104.698 52.8237C104.573 52.7517 104.588 52.6258 104.733 52.5426L111.966 48.3696C112.11 48.2864 112.328 48.2773 112.453 48.3495L119.756 52.5629C119.881 52.6349 119.865 52.7608 119.721 52.844L112.488 57.0167C112.344 57.1001 112.126 57.109 112.001 57.0371Z",
    fill: "#0076FC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2402 31.8599L101.572 25.5169",
    stroke: "#0076FC",
    strokeWidth: 0.2
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.5736 26.9085L62.6055 21.7348C62.4521 21.6463 62.4714 21.4917 62.6485 21.3896L71.5302 16.2657C71.7073 16.1635 71.9753 16.1525 72.1285 16.2408L81.0965 21.4145C81.25 21.5031 81.2307 21.6577 81.0536 21.7597L72.1719 26.8836C71.9948 26.9859 71.7268 26.9969 71.5736 26.9085Z",
    fill: "#0076FC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8261 29.5625C71.6664 29.5625 71.5132 29.5293 71.3961 29.4619L58.2775 21.8937C58.1484 21.8193 58.0771 21.7112 58.0771 21.5896C58.0771 21.4508 58.1731 21.316 58.3404 21.2193L71.333 13.724C71.6235 13.5563 72.0509 13.5404 72.3063 13.6877L85.4249 21.2558C85.5543 21.3303 85.6253 21.4384 85.6253 21.5599C85.6253 21.6987 85.5294 21.8336 85.362 21.9302L72.3694 29.4258C72.212 29.516 72.0148 29.5625 71.8261 29.5625ZM71.4939 29.2924C71.6876 29.4042 72.0439 29.3878 72.2716 29.2561L85.2642 21.7605C85.3678 21.7008 85.4297 21.6257 85.4297 21.5595C85.4297 21.4971 85.3739 21.4516 85.3272 21.4249L72.2085 13.8565C72.015 13.7449 71.6588 13.7613 71.4308 13.8928L58.4382 21.3884C58.3346 21.4481 58.2727 21.5232 58.2727 21.5894C58.2727 21.652 58.3286 21.6973 58.3753 21.724L71.4939 29.2924Z",
    fill: "#0076FC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1991 17.9095V16.181L78.3812 16.1829L72.129 12.5759C71.9755 12.4873 71.7077 12.4985 71.5304 12.6008L65.306 16.1916L62.502 16.1935L62.5024 17.9263H62.504C62.5065 17.9801 62.5387 18.0313 62.6056 18.0699L71.5736 23.2436C71.727 23.3322 71.9948 23.321 72.1721 23.2187L81.0538 18.0948C81.1462 18.0417 81.1946 17.9745 81.1991 17.9095Z",
    fill: "url(#paint24_linear_169_467)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5745 21.515L62.6065 16.3413C62.4531 16.2527 62.4724 16.0981 62.6495 15.9961L71.5311 10.8722C71.7082 10.7699 71.9763 10.7589 72.1295 10.8473L81.0975 16.021C81.2509 16.1096 81.2316 16.2641 81.0545 16.3662L72.1729 21.4901C71.9958 21.5924 71.7277 21.6034 71.5745 21.515Z",
    fill: "url(#paint25_linear_169_467)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6056 20.9088L63.6563 16.3229C63.5203 16.2444 63.5373 16.1073 63.6943 16.0169L71.5672 11.4749C71.7241 11.3842 71.9616 11.3745 72.0976 11.4529L80.0469 16.0389C80.1829 16.1173 80.1659 16.2544 80.0089 16.3448L72.136 20.8868C71.9791 20.9775 71.7416 20.9873 71.6056 20.9088Z",
    fill: "#0076FC"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6258 20.5249L64.3226 16.3115C64.1977 16.2395 64.2134 16.1136 64.3575 16.0304L71.5905 11.8574C71.7348 11.7742 71.953 11.7651 72.078 11.8373L79.3812 16.0507C79.5062 16.1227 79.4904 16.2486 79.3463 16.3318L72.1133 20.5045C71.9688 20.5879 71.7506 20.5968 71.6258 20.5249Z",
    fill: "#0076FC"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7451 16.7002L63.9389 26.5543L64.977 25.6207",
    stroke: "#0076FC",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_467",
    x1: 23.9384,
    y1: 16.0428,
    x2: 9.37736,
    y2: 27.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#5C7DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_169_467",
    x1: 26.6925,
    y1: 19.6044,
    x2: 6.42923,
    y2: 13.2707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2978,
    stopColor: "#C5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6488,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_169_467",
    x1: 48.8906,
    y1: 2.01152,
    x2: 34.3295,
    y2: 13.6968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#5C7DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_169_467",
    x1: 51.6447,
    y1: 5.57312,
    x2: 31.3814,
    y2: -0.760534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2978,
    stopColor: "#C5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6488,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_169_467",
    x1: 55.7656,
    y1: 39.1458,
    x2: 41.2045,
    y2: 50.8311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#5C7DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_169_467",
    x1: 58.5197,
    y1: 42.7074,
    x2: 38.2564,
    y2: 36.3737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2978,
    stopColor: "#C5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6488,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_169_467",
    x1: 90.5847,
    y1: 34.2498,
    x2: 76.0236,
    y2: 45.9351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#5C7DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_169_467",
    x1: 93.338,
    y1: 37.8114,
    x2: 73.0747,
    y2: 31.4777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2978,
    stopColor: "#C5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6488,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_169_467",
    x1: 93.338,
    y1: 37.8114,
    x2: 73.0747,
    y2: 31.4777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2978,
    stopColor: "#C5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6488,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_169_467",
    x1: 90.5849,
    y1: 30.4197,
    x2: 76.0238,
    y2: 42.1049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0076FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#0076FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#0076FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#0076FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#0076FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_169_467",
    x1: 93.3382,
    y1: 33.981,
    x2: 73.0749,
    y2: 27.6473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2978,
    stopColor: "#C5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6488,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_169_467",
    x1: 112.291,
    y1: 11.762,
    x2: 97.7299,
    y2: 23.4473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#5C7DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_169_467",
    x1: 115.045,
    y1: 15.3236,
    x2: 94.7818,
    y2: 8.98995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2978,
    stopColor: "#C5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6488,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_169_467",
    x1: 29.2275,
    y1: 53.5916,
    x2: 14.6664,
    y2: 65.2769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#5C7DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_169_467",
    x1: 31.9816,
    y1: 57.1532,
    x2: 11.7183,
    y2: 50.8195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2978,
    stopColor: "#C5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6488,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_169_467",
    x1: 67.3925,
    y1: 60.5135,
    x2: 52.8315,
    y2: 72.1987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#5C7DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_169_467",
    x1: 70.1466,
    y1: 64.0751,
    x2: 49.8833,
    y2: 57.7414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2978,
    stopColor: "#C5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6488,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_169_467",
    x1: 95.8727,
    y1: 71.7991,
    x2: 81.3117,
    y2: 83.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#5C7DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_169_467",
    x1: 98.6261,
    y1: 75.3607,
    x2: 78.3628,
    y2: 69.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2978,
    stopColor: "#C5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6488,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_169_467",
    x1: 98.6261,
    y1: 75.3607,
    x2: 78.3628,
    y2: 69.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2978,
    stopColor: "#C5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6488,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_169_467",
    x1: 95.872,
    y1: 67.969,
    x2: 81.3109,
    y2: 79.6542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0076FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#0076FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#0076FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#0076FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#0076FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_169_467",
    x1: 98.6253,
    y1: 71.5303,
    x2: 78.362,
    y2: 65.1966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2978,
    stopColor: "#C5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6488,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_169_467",
    x1: 117.58,
    y1: 49.3113,
    x2: 103.019,
    y2: 60.9966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#5C7DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_169_467",
    x1: 120.334,
    y1: 52.8729,
    x2: 100.071,
    y2: 46.5393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2978,
    stopColor: "#C5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6488,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_169_467",
    x1: 77.205,
    y1: 12.7991,
    x2: 62.644,
    y2: 24.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#5C7DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_169_467",
    x1: 79.9591,
    y1: 16.3607,
    x2: 59.6958,
    y2: 10.0271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2978,
    stopColor: "#C5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6488,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsortiumIcon);
export default __webpack_public_path__ + "static/media/consortium-icon.a475441b6ce357abe0b7f335b9edc766.svg";
export { ForwardRef as ReactComponent };